"use strict";

import "./Tabs.css";
import React from "react";
import classnames from "classnames";

export default class Tabs extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		
		let defaultTabId = this.props.children.length > 0 ? this.props.children[0].props.id : null;
		
		this.state = {
			selected: "selected" in this.props ? this.props.selected : defaultTabId
		};
	}
	
	shouldComponentUpdate(nextProps, nextState) {
		if ("selected" in nextState)
			return true;
		return "selected" in nextProps;
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.selected != this.props.selected) {
			this.setState({
				selected: nextProps.selected
			});
		}
	}
	
	select(id) {
		if (id == this.state.selected)
			return;
		
		this.setState({
			selected: id
		});
		
		this.props.onChange(id);
	}
	
	renderTab(tab) {
		
		let className = this.state.selected == tab.props.id ? "Selected" : "";
		
		return (
			<li key={tab.props.id} className={className} onClick={() => this.select(tab.props.id)}>
				{tab.props.children}
			</li>
		);
	}
	
	render() {
		return (
			<ul className={classnames(this.props.className, "Tabs")}>
				{this.props.children.map(tab => this.renderTab(tab))}
			</ul>
		);
	}
	
}

Tabs.propTypes = {
	onChange: React.PropTypes.func,
	selected: React.PropTypes.string
};

Tabs.defaultProps = {
	onChange: id => {}
};


// WEBPACK FOOTER //
// ./~/vwa/components/Tabs/Tabs.jsx